var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"word-cloud-view",class:{
    'is-allow-text-removal': _vm.isAllowedTextRemoval,
  },attrs:{"id":`word-cloud-${_vm.id}`}})
}
var staticRenderFns = []

export { render, staticRenderFns }